import React from 'react';
import './PageTitle.scss';

const PageTitle = ({title,description}) => {
    return (
        <div className='page-title'>
            <div className="container">
                <h2>Haberler ve Makaleler</h2>
                <p>En güncel blog içeriklerimizi takip edin, ağız ve diş sağlığı için yararlı ipuçları keşfedin.</p>
            </div>
        </div> 
    );
};

export default PageTitle;